
import { Component, Mixins } from 'vue-property-decorator';
import CommonRankName from '@/components/common/CommonRankName.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import { SingleRankMixin } from '@/utils/mixin';
@Component({
  components: {
    CommonRankName,
    CommonRankNumber,
    CommonLoading,
  },
})
export default class SingleCover extends Mixins(SingleRankMixin) {
  mounted() {
    this.domIndex = 1;
    this.refName = 'singlecover';
  }
}
